import { Box, Icon } from '@bechtel/gds';
import { OrderStatusTabProps, OrderStatusType, orderStatusTabs } from '@bechtel/ht-clients-common';
import { ToolOrderStatsResult } from '@bechtel/ht-types';
import { map } from 'lodash';
import { FC } from 'react';
import LoadingIndicator from '~/components/loading-indicator';
import { StatIndicator } from '~/components/stat-indicator';
import { SecondaryTextStyled, TabAdminButtonStyled } from '~/styles';
import { HeaderTabProps } from './types';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-ignore
const TabItem = ({ name, type, active, isPinnable, count, statsIndicator, onSelect }: OrderStatusTabProps) => {
  return (
    <TabAdminButtonStyled
      selected={active}
      onClick={() => {
        onSelect && onSelect(type);
      }}
    >
      {statsIndicator && <StatIndicator status={type} />}
      <SecondaryTextStyled family="openSansCondensed">{name}</SecondaryTextStyled> &nbsp;
      {<SecondaryTextStyled>({count})</SecondaryTextStyled>}
      {isPinnable && (
        <Box>
          <Icon icon="thumbtack" iconStyle="solid" fillColor="grey.300"></Icon>
        </Box>
      )}
    </TabAdminButtonStyled>
  );
};
// export enum StatsFilterType {
//   User = 'User',
//   ToolRoom = 'ToolRoom',
// }
// interface HeaderTabProps {
//   selectedStatuses: OrderStatusType[];
//   onSelectStatus: React.Dispatch<StateSelectionProps>;
//   toolRoomOrUserId?: string;
//   statsFilterType: StatsFilterType;
//   pinOption?: boolean;
//   statsIndicator?: boolean;
// }
export const getStatsCount = (tabType: string, toolOrderStats: ToolOrderStatsResult | null) => {
  if (!toolOrderStats) return null;
  switch (tabType) {
    case OrderStatusType.Open:
      return toolOrderStats.openCount;
    case OrderStatusType.Cancelled:
      return toolOrderStats.cancelledCount;
    case OrderStatusType.Completed:
      return toolOrderStats.completedCount;
    case OrderStatusType.OutofStock:
      return toolOrderStats.outOfStockCount;
    case OrderStatusType.Prepared:
      return toolOrderStats.preparedCount;
  }
};
export const PageHeaderTabs: FC<HeaderTabProps> = ({
  selectedStatuses,
  onSelectStatus,
  pinOption = false,
  statsIndicator = false,
  toolOrderStatsResult,
  loading,
}) => {
  if (loading)
    return (
      <Box style={{ width: '50%' }}>
        <LoadingIndicator></LoadingIndicator>
      </Box>
    );

  return (
    <Box gap={{ sm: '100' }} mt={{ sm: '200' }}>
      {map(orderStatusTabs, (tab, index) => (
        <TabItem
          {...tab}
          key={index}
          onSelect={() => {
            onSelectStatus({ type: 'SELECT', selectedStatus: tab.type });
          }}
          active={selectedStatuses.includes(tab.type)}
          count={getStatsCount(tab.type, toolOrderStatsResult) || 0}
          isPinnable={pinOption && tab.isPinnable}
          statsIndicator={statsIndicator}
        />
      ))}
    </Box>
  );
};
